<template>
<section class="tool">
 <section class="tool-title">
    <span class="toolList">Web全栈开发导航，持续更新，可收藏本页面</span>
 </section>
 <section class="row" v-for='row in allSite'>
    <div class="tool-container" v-for='category in row["website"]'>
       <div class="tool-name">{{ category.name }}</div>
       <ul class="tool-type-ul">
         <li v-for='item in category["items"]' key='index'>
            <a :href='item.href' target="_blank">
              <img :src='item.url' :title="item.title" />
            </a>
         </li>
       </ul>
   </div>
 </section>
</section>
</template>

<script>
export default {
  data(){
    return{
        allSite:[{
              website:[{
                  name:'浏览器↓↓↓',
                  items:[{
                     title:'Chrome',
                     url:require('../../../static/images/icons/chrome.ico'),
                     href:'https://www.google.com/chrome/'
                 },{
                     title:'Firefox',
                     url:require('../../../static/images/icons/firefox.png'),
                     href:'https://www.mozilla.org/en-US/firefox/products/'
                 },{
                      title:'Safari',
                      url:require('../../../static/images/icons/safari.png'),
                      href:'http://www.apple.com/safari/'
                 },{
                      title:'Opera',
                      url:require('../../../static/images/icons/opera.png'),
                      href:'http://www.opera.com/'
                 },{
                      title:'IE',
                      url:require('../../../static/images/icons/edge.png'),
                      href:'https://www.microsoft.com/zh-cn/windows/microsoft-edge/'
                 }]
            },{
               name:'搜索引擎服务/代码版本管理↓↓↓',
               items:[{
                 title:'Google',
                 url:require('../../../static/images/icons/google.png'),
                 href:'https://www.google.com/'
               },{
                 title:'Baidu',
                 url:require('../../../static/images/icons/baidu.png'),
                 href:'https://www.baidu.com/'
               },{
                   title:'Git',
                   url:require('../../../static/images/icons/git.png'),
                   href:'http://git-scm.com/'
                },{
                   title:'Mercurial',
                   url:require('../../../static/images/icons/mercurial.png'),
                   href:'https://www.mercurial-scm.org/'
                },{
                   title:'SVN',
                   url:require('../../../static/images/icons/svn.png'),
                   href:'http://subversion.apache.org/'
                }]
            },{
               name:'翻墙工具/免费VPN↓↓↓',
               items:[{
                   title:'Lantern',
                   url:require('../../../static/images/icons/lantern.png'),
                   href:'https://github.com/getlantern/lantern/'
                 },{
                   title:'XX-Net',
                   url:require('../../../static/images/icons/xx-net.png'),
                   href:'https://github.com/XX-net/XX-Net/'
                 },{
                   title:'Tor',
                   url:require('../../../static/images/icons/tor-logo.png'),
                   href:'https://www.torproject.org/'
                 },{
                   title:'Softether',
                   url:require('../../../static/images/icons/softether.ico'),
                   href:'https://www.softether.org/'
                 },{
                   title:'Shadowsocks',
                   url:require('../../../static/images/icons/shadowsocks.png'),
                   href:'https://shadowsocks.org/'
                }]
            }]
        },{
            website:[{
                  name:'代码托管及在线开发↓↓↓',
                  items:[{
                     title:'Github',
                     url:require('../../../static/images/icons/github.png'),
                     href:'https://github.com/'
                 },{
                     title:'Coding',
                     url:require('../../../static/images/icons/coding.png'),
                     href:'https://coding.net/'
                 },{
                      title:'Bitbucket',
                      url:require('../../../static/images/icons/bitbucket.ico'),
                      href:'http://www.bitbucket.org/'
                 },{
                      title:'Gitlab',
                      url:require('../../../static/images/icons/gitlab.png'),
                      href:'http://gitlab.com/'
                 },{
                      title:'JSFiddle',
                      url:require('../../../static/images/icons/jsfiddle.png'),
                      href:'http://jsfiddle.net/'
                 },{
                      title:'CodePen',
                      url:require('../../../static/images/icons/codepen.png'),
                      href:'https://codepen.io/'
                 }]
            },{
               name:'热门前端框架↓↓↓',
               items:[{
                   title:'Vue',
                   url:require('../../../static/images/icons/vue.png'),
                   href:'https://vuefe.cn/v2/guide/'
                 },{
                   title:'Angular',
                   url:require('../../../static/images/icons/angular.png'),
                   href:'http://angular.io/'
                 },{
                   title:'React',
                   url:require('../../../static/images/icons/react.png'),
                   href:'http://facebook.github.io/react/'
                 },{
                   title:'JQuery',
                   url:require('../../../static/images/icons/jquery.png'),
                   href:'http://jquery.com/'
                 },{
                   title:'JQuery Mobile',
                   url:require('../../../static/images/icons/jquerymobile.png'),
                   href:'http://jquerymobile.com/'
                 },{
                   title:'微信小程序',
                   url:require('../../../static/images/icons/wx.png'),
                   href:'https://mp.weixin.qq.com/debug/wxadoc/dev/index.html'
                }]
            },{
               name:'编辑器及Markdown在线编辑器↓↓↓',
               items:[{
                 title:'Sublime',
                 url:require('../../../static/images/icons/sublime.png'),
                 href:'http://www.sublimetext.com/'
               },{
                 title:'Notepad++',
                 url:require('../../../static/images/icons/notepad.png'),
                 href:'https://notepad-plus-plus.org/'
               },{
                   title:'Vim',
                   url:require('../../../static/images/icons/vim.png'),
                   href:'http://www.vim.org/'
                },{
                   title:'Emacs',
                   url:require('../../../static/images/icons/emacs.png'),
                   href:'http://www.gnu.org/software/emacs/'
                },{
                   title:'MaHua',
                   url:require('../../../static/images/icons/mahua.png'),
                   href:'http://mahua.jser.me/'
                },{
                   title:'ZYBuLuo',
                   url:require('../../../static/images/icons/zybuluo.png'),
                   href:'https://www.zybuluo.com/'
                }]
            }]
        },{
            website:[{
                  name:'开发语言↓↓↓',
                  items:[{
                     title:'Java',
                     url:require('../../../static/images/icons/java.png'),
                     href:'https://www.java.com/zh_CN/'
                 },{
                     title:'JavaScript-Nodejs',
                     url:require('../../../static/images/icons/nodejs.png'),
                     href:'http://nodejs.org/'
                 },{
                      title:'Python',
                      url:require('../../../static/images/icons/python.png'),
                      href:'https://www.python.org/'
                 },{
                      title:'Php',
                      url:require('../../../static/images/icons/php.png'),
                      href:'http://php.net/'
                 },{
                      title:'Ruby',
                      url:require('../../../static/images/icons/ruby.png'),
                      href:'https://www.ruby-lang.org/'
                 },{
                      title:'Swift',
                      url:require('../../../static/images/icons/swift.png'),
                      href:'https://developer.apple.com/swift/'
                 },{
                      title:'Go',
                      url:require('../../../static/images/icons/go.png'),
                      href:'https://developer.apple.com/swift/'
                 }]
            },{
               name:'常用IDE↓↓↓',
               items:[{
                 title:'WebStorm',
                 url:require('../../../static/images/icons/webstorm.png'),
                 href:'https://www.jetbrains.com/webstorm/'
               },{
                 title:'HBuilder',
                 url:require('../../../static/images/icons/hbuilder.png'),
                 href:'http://www.dcloud.io/'
               },{
                   title:'Atom',
                   url:require('../../../static/images/icons/atom.ico'),
                   href:'https://atom.io/'
                },{
                   title:'Eclipse',
                   url:require('../../../static/images/icons/eclipse.png'),
                   href:'https://eclipse.org/'
                },{
                   title:'Visual Studio',
                   url:require('../../../static/images/icons/vscode.png'),
                   href:'https://code.visualstudio.com/'
                },{
                   title:'NetBeans',
                   url:require('../../../static/images/icons/netbeans.png'),
                   href:'https://netbeans.org/'
                },{
                   title:'Android-Studio',
                   url:require('../../../static/images/icons/studio.png'),
                   href:'http://developer.android.com/sdk/index.html'
                },{
                   title:'XCode',
                   url:require('../../../static/images/icons/xcode.png'),
                   href:'https://developer.apple.com/xcode/ide/'
                }]
            }]
        },{
            website:[{
                  name:'常用UI框架↓↓↓',
                  items:[{
                     title:'Bootstrap',
                     url:require('../../../static/images/icons/bootstrap.png'),
                     href:'http://getbootstrap.com/'
                 },{
                      title:'Semantic UI',
                      url:require('../../../static/images/icons/semantic.png'),
                      href:'http://semantic-ui.com/'
                 },{
                      title:'Purecss',
                      url:require('../../../static/images/icons/purecss.ico'),
                      href:'http://purecss.io/'
                 },{
                     title:'FrozenUI',
                     url:require('../../../static/images/icons/frozen.png'),
                     href:'http://frozenui.github.io/'
                 },{
                      title:'WeUI',
                      url:require('../../../static/images/icons/wx.png'),
                      href:'https://weui.io/'
                 },{
                      title:'Win8',
                      url:require('../../../static/images/icons/wn8.png'),
                      href:'http://metroui.org.ua/'
                 },{
                      title:'Ionic',
                      url:require('../../../static/images/icons/ionic.png'),
                      href:'http://ionicframework.com/'
                 },{
                      title:'Appframework',
                      url:require('../../../static/images/icons/intel.png'),
                      href:'https://github.com/01org/appframework/'
                 },{
                      title:'Polymer',
                      url:require('../../../static/images/icons/polymer.png'),
                      href:'https://github.com/Polymer/polymer/'
                 }]
            },{
               name:'常用插件/Web字体↓↓↓',
               items:[{
                 title:'Babel',
                 url:require('../../../static/images/icons/babel.png'),
                 href:'https://babeljs.io/'
                },{
                   title:'Normalize',
                   url:require('../../../static/images/icons/normalize.png'),
                   href:'http://necolas.github.io/normalize.css/'
                },{
                   title:'Hammer',
                   url:require('../../../static/images/icons/hammer.png'),
                   href:'http://hammerjs.github.io/'
                },{
                   title:'FastClick',
                   url:require('../../../static/images/icons/fastclick.png'),
                   href:'https://github.com/ftlabs/fastclick/'
                },{
                   title:'Swiper',
                   url:require('../../../static/images/icons/swiper.png'),
                   href:'http://idangero.us/swiper/'
                },{
                   title:'IScroll',
                   url:require('../../../static/images/icons/iscroll.png'),
                   href:'http://iscrolljs.com/'
                },{
                 title:'Font Awesome',
                 url:require('../../../static/images/icons/fontawesome.ico'),
                 href:'http://fontawesome.io/'
               },{
                 title:'Icon Font',
                 url:require('../../../static/images/icons/iconfont.ico'),
                 href:'http://iconfont.cn/'
               },]
            }]
        },{
          website:[{
                  name:'模块化/构建/预处理器↓↓↓',
                  items:[{
                     title:'Require',
                     url:require('../../../static/images/icons/require.png'),
                     href:'http://requirejs.org/'
                 },{
                      title:'Sea',
                      url:require('../../../static/images/icons/sea.png'),
                      href:'http://seajs.org/docs/'
                 },{
                     title:'Gulp',
                     url:require('../../../static/images/icons/gulp.png'),
                     href:'http://gulpjs.com/'
                 },{
                      title:'Grunt',
                      url:require('../../../static/images/icons/grunt.png'),
                      href:'http://gruntjs.com/'
                 },{
                     title:'Yeoman',
                     url:require('../../../static/images/icons/yeoman.png'),
                     href:'http://yeoman.io/'
                 },{
                      title:'Bower',
                      url:require('../../../static/images/icons/bower.png'),
                      href:'https://bower.io/'
                 },{
                      title:'Webpack',
                      url:require('../../../static/images/icons/webpack.png'),
                      href:'https://webpack.github.io/'
                 },{
                      title:'Sass',
                      url:require('../../../static/images/icons/sass.png'),
                      href:'http://sass-lang.com/'
                 },{
                      title:'Less',
                      url:require('../../../static/images/icons/less.png'),
                      href:'http://lesscss.org/'
                 },{
                      title:'Stylus',
                      url:require('../../../static/images/icons/stylus.png'),
                      href:'http://stylus-lang.com/'
                 }]
            },{
               name:'NodeJS后端全栈框架↓↓↓',
               items:[{
                   title:'Express',
                   url:require('../../../static/images/icons/expressjs.png'),
                   href:'http://expressjs.com/'
                },{
                   title:'Koa',
                   url:require('../../../static/images/icons/koa.png'),
                   href:'http://koajs.com/'
                },{
                   title:'Sails',
                   url:require('../../../static/images/icons/sails.png'),
                   href:'http://sailsjs.org/'
                },{
                   title:'Meteor',
                   url:require('../../../static/images/icons/meteor.png'),
                   href:'http://www.meteor.com/'
                },{
                   title:'Socket',
                   url:require('../../../static/images/icons/socket.io.png'),
                   href:'http://socket.io/'
                },{
                 title:'Hapi',
                 url:require('../../../static/images/icons/hapi.png'),
                 href:'http://hapijs.com/'
               },{
                 title:'Loopback',
                 url:require('../../../static/images/icons/loopBack.png'),
                 href:'http://loopback.io/'
               },{
                 title:'Pug',
                 url:require('../../../static/images/icons/pug.png'),
                 href:'https://pugjs.org/api/getting-started.html'
               }]
            }]
        },{
            website:[{
                  name:'混合移动开发/App技术↓↓↓',
                  items:[{
                     title:'Cordova',
                     url:require('../../../static/images/icons/cordova.png'),
                     href:'https://cordova.apache.org/'
                 },{
                      title:'React Native',
                      url:require('../../../static/images/icons/react-native.png'),
                      href:'https://facebook.github.io/react-native/'
                 },{
                     title:'NativeScript',
                     url:require('../../../static/images/icons/nativescript.png'),
                     href:'https://www.nativescript.org/'
                 },{
                      title:'CrossWalk',
                      url:require('../../../static/images/icons/crosswalk.ico'),
                      href:'https://crosswalk-project.org/'
                 },{
                     title:'FireBase',
                     url:require('../../../static/images/icons/firebase.png'),
                     href:'https://www.firebase.com/'
                 }]
            },{
               name:'BaaS/原型设计/UI↓↓↓',
               items:[{
                   title:'LeanCloud',
                   url:require('../../../static/images/icons/leancloud.png'),
                   href:'https://leancloud.cn/'
                },{
                   title:'Bmob',
                   url:require('../../../static/images/icons/bmob.ico'),
                   href:'http://www.bmob.cn/'
                },{
                   title:'野狗',
                   url:require('../../../static/images/icons/yegou.png'),
                   href:'https://www.wilddog.com/'
                },{
                   title:'Sketch',
                   url:require('../../../static/images/icons/sketch.png'),
                   href:'https://sketchapp.com/'
                },{
                   title:'Axure',
                   url:require('../../../static/images/icons/axure.png'),
                   href:'http://www.axure.com/'
                },{
                   title:'墨刀',
                   url:require('../../../static/images/icons/modao.ico'),
                   href:'https://modao.cc/'
                }]
            },{
               name:'反向代理服务工具↓↓↓',
               items:[{
                   title:'Ngrok',
                   url:require('../../../static/images/icons/ngrok.png'),
                   href:'https://ngrok.com/'
                },{
                   title:'Charles',
                   url:require('../../../static/images/icons/charles.png'),
                   href:'https://www.charlesproxy.com/'
                },{
                   title:'Localtunnel',
                   url:require('../../../static/images/icons/localtunnel.ico'),
                   href:'http://localtunnel.me/'
                },{
                   title:'Pagekite',
                   url:require('../../../static/images/icons/pagekite.png'),
                   href:'http://pagekite.net/'
                },{
                   title:'NATAPP',
                   url:require('../../../static/images/icons/natapp.png'),
                   href:'https://natapp.cn/'
                }]
            }]
        },{
          website:[{
              name:'云技术/云主机/云存储/Web服务器↓↓↓',
              items:[{
                 title:'Digital Ocean',
                 url:require('../../../static/images/icons/digitalocean.png'),
                 href:'https://www.digitalocean.com/'
              },{
                 title:'Google Cloud',
                 url:require('../../../static/images/icons/google-cloud.png'),
                 href:'https://cloud.google.com/'
              },{
                 title:'Open Shift',
                 url:require('../../../static/images/icons/openshift.png'),
                 href:'https://www.openshift.com/'
              },{
                 title:'Azure',
                 url:require('../../../static/images/icons/azure.ico'),
                 href:'http://azure.microsoft.com/'
              },{
                 title:'Linode',
                 url:require('../../../static/images/icons/linode.png'),
                 href:'https://www.linode.com/'
              },{
                 title:'Heroku',
                 url:require('../../../static/images/icons/heroku.png'),
                 href:'https://www.heroku.com/'
              },{
                 title:'Hadoop',
                 url:require('../../../static/images/icons/hadoop.png'),
                 href:'http://hadoop.apache.org/'
              },{
                 title:'Google Cloud',
                 url:require('../../../static/images/icons/google-cloud.png'),
                 href:'https://cloud.google.com/'
              },{
                 title:'Docker',
                 url:require('../../../static/images/icons/docker.png'),
                 href:'https://www.docker.com/'
              },{
                 title:'七牛云',
                 url:require('../../../static/images/icons/qiniu.png'),
                 href:'http://www.qiniu.com/'
              },{
                 title:'AliYun',
                 url:require('../../../static/images/icons/aliyun.jpg'),
                 href:'http://www.aliyun.com/'
              },{
                 title:'Aws',
                 url:require('../../../static/images/icons/aws.png'),
                 href:'http://aws.amazon.com/'
              },{
                 title:'腾讯云',
                 url:require('../../../static/images/icons/tencent-cloud.png'),
                 href:'https://www.qcloud.com/'
              },{
                 title:'Tomcat',
                 url:require('../../../static/images/icons/tomcat.png'),
                 href:'http://tomcat.apache.org/'
              },{
                 title:'IIS',
                 url:require('../../../static/images/icons/iis.png'),
                 href:'https://www.iis.net/'
              },{
                 title:'Nginx',
                 url:require('../../../static/images/icons/nginx.png'),
                 href:'https://nginx.org/'
              }]
          }]
        },{
            website:[{
                  name:'数据库/分布式缓存↓↓↓',
                  items:[{
                     title:'MySQL',
                     url:require('../../../static/images/icons/mysql.png'),
                     href:'http://www.mysql.com/'
                 },{
                      title:'Oracle',
                      url:require('../../../static/images/icons/oracle.png'),
                      href:'https://www.oracle.com/index.html'
                 },{
                     title:'SQL Server',
                     url:require('../../../static/images/icons/sqlserver.png'),
                     href:'https://www.microsoft.com/zh-cn/server-cloud/products/sql-server/default.aspx'
                 },{
                      title:'PostgreSQL',
                      url:require('../../../static/images/icons/postgresql.png'),
                      href:'http://www.postgresql.org/'
                 },{
                     title:'MongoDB',
                     url:require('../../../static/images/icons/mongodb.png'),
                     href:'https://www.mongodb.org/'
                 },{
                     title:'MariaDB',
                     url:require('../../../static/images/icons/mariadb.png'),
                     href:'https://mariadb.com/'
                 },{
                     title:'Lovefield',
                     url:require('../../../static/images/icons/lovefield.png'),
                     href:'https://google.github.io/lovefield/'
                 },{
                     title:'SQLite',
                     url:require('../../../static/images/icons/sqlite.png'),
                     href:'https://www.sqlite.org/'
                 },{
                     title:'Memcached',
                     url:require('../../../static/images/icons/memcached.png'),
                     href:'http://memcached.org/'
                 },{
                     title:'Redis',
                     url:require('../../../static/images/icons/redis.png'),
                     href:'https://redis.io/'
                 },{
                     title:'Greenplum',
                     url:require('../../../static/images/icons/greenplumdb.png'),
                     href:'http://greenplum.org/'
                 }]
            }]
        },{
            website:[{
                  name:'静态博客↓↓↓',
                  items:[{
                     title:'Hexo',
                     url:require('../../../static/images/icons/hexo.png'),
                     href:'https://hexo.io/'
                 },{
                      title:'Jekyllrb',
                      url:require('../../../static/images/icons/jekyllrb.png'),
                      href:'https://jekyllrb.com/'
                 },{
                     title:'Surge',
                     url:require('../../../static/images/icons/surge.png'),
                     href:'http://surge.sh/'
                 },{
                      title:'Netlify',
                      url:require('../../../static/images/icons/netlify.png'),
                      href:'https://www.netlify.com/'
                 }]
            },{
               name:'短信平台↓↓↓',
               items:[{
                   title:'Twilio',
                   url:require('../../../static/images/icons/twilio.png'),
                   href:'https://www.twilio.com/'
                },{
                   title:'7GLink',
                   url:require('../../../static/images/icons/7glink.png'),
                   href:'http://7glink.com/'
                },{
                   title:'云片网',
                   url:require('../../../static/images/icons/yunpian.png'),
                   href:'https://www.yunpian.com/'
                }]
            },{
               name:'移动支付↓↓↓',
               items:[{
                   title:'Pingxx',
                   url:require('../../../static/images/icons/pingxx.ico'),
                   href:'https://www.pingxx.com/'
                },{
                   title:'Beecloud',
                   url:require('../../../static/images/icons/beecloud.ico'),
                   href:'https://beecloud.cn/'
                },{
                   title:'支付宝',
                   url:require('../../../static/images/icons/zfb.ico'),
                   href:'https://open.alipay.com/'
                },{
                   title:'微信',
                   url:require('../../../static/images/icons/wx.png'),
                   href:'https://pay.weixin.qq.com/'
                }]
            },{
               name:'网络安全↓↓↓',
               items:[{
                   title:'Lets Encrypt',
                   url:require('../../../static/images/icons/letsencrypt.png'),
                   href:'https://letsencrypt.org/'
                },{
                   title:'Node Security',
                   url:require('../../../static/images/icons/nodesecurity.png'),
                   href:'https://nodesecurity.io/'
                },{
                   title:'StartSSL',
                   url:require('../../../static/images/icons/startssl.png'),
                   href:'https://www.startssl.com/'
                }]
            }]
        },{
            website:[{
                  name:'单元测试/自动化测试/持续集成↓↓↓',
                  items:[{
                     title:'JUnit',
                     url:require('../../../static/images/icons/junit.png'),
                     href:'http://junit.org/junit4/'
                 },{
                     title:'Mocha',
                     url:require('../../../static/images/icons/mocha.png'),
                     href:'http://mochajs.org/'
                 },{
                      title:'Jasmine',
                      url:require('../../../static/images/icons/jasmine.png'),
                      href:'http://jasmine.github.io/'
                 },{
                     title:'Karma',
                     url:require('../../../static/images/icons/karma.png'),
                     href:'http://karma-runner.github.io/'
                 },{
                      title:'QUnit',
                      url:require('../../../static/images/icons/qunitjs.ico'),
                      href:'http://qunitjs.com/'
                 },{
                      title:'Selenium',
                      url:require('../../../static/images/icons/selenium.png'),
                      href:'http://www.seleniumhq.org/'
                 },{
                      title:'MonkeyRunner',
                      url:require('../../../static/images/icons/studio.png'),
                      href:'https://developer.android.com/studio/test/monkeyrunner/'
                 },{
                      title:'Postman',
                      url:require('../../../static/images/icons/postman.png'),
                      href:'https://www.getpostman.com/'
                 },{
                      title:'LoadRunner',
                      url:require('../../../static/images/icons/loadrunner.png'),
                      href:'http://www8.hp.com/cn/zh/software-solutions/loadrunner-load-testing/'
                 },{
                      title:'Jenkins',
                      url:require('../../../static/images/icons/jenkins.png'),
                      href:'https://jenkins.io/'
                 },{
                      title:'Travis',
                      url:require('../../../static/images/icons/travis.png'),
                      href:'https://travis-ci.org/'
                 },{
                      title:'Saucelabs',
                      url:require('../../../static/images/icons/saucelabs.png'),
                      href:'https://saucelabs.com/'
                 },{
                      title:'BrowserStack',
                      url:require('../../../static/images/icons/browserstack.png'),
                      href:'https://www.browserstack.com/'
                 }]
            }]
        },{
            website:[{
                  name:'Unix/Linux↓↓↓',
                  items:[{
                     title:'Redhat',
                     url:require('../../../static/images/icons/redhat.png'),
                     href:'https://www.redhat.com/'
                 },{
                      title:'Debian',
                      url:require('../../../static/images/icons/debian.png'),
                      href:'https://www.debian.org/'
                 },{
                     title:'Centos',
                     url:require('../../../static/images/icons/centos.png'),
                     href:'https://www.centos.org/'
                 },{
                      title:'Ubuntu',
                      url:require('../../../static/images/icons/ubuntu.png'),
                      href:'http://www.ubuntu.com/'
                 },{
                     title:'Arch',
                     url:require('../../../static/images/icons/arch.png'),
                     href:'https://www.archlinux.org/'
                 },{
                     title:'Gentoo',
                     url:require('../../../static/images/icons/gentoo.png'),
                     href:'https://www.gentoo.org/'
                 }]
            },{
               name:'博主推荐↓↓↓',
               items:[{
                   title:'WhyCSS',
                   url:require('../../../static/images/icons/whycss.png'),
                   href:'http://whycss.com/'
                },{
                   title:'简书',
                   url:require('../../../static/images/icons/jianshu.png'),
                   href:'http://www.jianshu.com/'
                },{
                   title:'SegmentFault',
                   url:require('../../../static/images/icons/sf.png'),
                   href:'https://segmentfault.com/'
                },{
                   title:'Div',
                   url:require('../../../static/images/icons/div.ico'),
                   href:'http://div.io/'
                },{
                   title:'Hostucan',
                   url:require('../../../static/images/icons/hostucan.png'),
                   href:'https://www.hostucan.cn/'
                }]
            },{
               name:'博主常用↓↓↓',
               items:[{
                   title:'Zealer',
                   url:require('../../../static/images/icons/zealer.png'),
                   href:'http://www.zealer.com/'
                },{
                   title:'海贼王',
                   url:require('../../../static/images/icons/ishuhui.png'),
                   href:'http://www.ishuhui.com/cartoon/book/1/'
                },{
                   title:'苹果团',
                   url:require('../../../static/images/icons/appletuan.png'),
                   href:'http://www.appletuan.com/'
                },{
                   title:'知乎',
                   url:require('../../../static/images/icons/zhihu.png'),
                   href:'https://www.zhihu.com/'
                },{
                   title:'开源中国',
                   url:require('../../../static/images/icons/oschina.png'),
                   href:'http://www.oschina.net/'
                }]
            }]
        }]
    }
  },
  methods:{
    toggleMenuList(){
      this.pageBoolean.showMenu=!this.pageBoolean.showMenu;
    },
    toggleLangList(){
      this.pageBoolean.showLang=!this.pageBoolean.showLang;
    }
  },
  mounted() {
    var self=this;
    this.$nextTick(()=>{
      document.title="黑工具导航";
    })
  }
}
</script>

<style>
*{
  margin: 0;
  padding: 0;
}
.tool{
  color: #FFF;
}
.tool-title{
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top:40px;
}
.toolList{
  font-size: 20px;
}
.row{
  display: flex;
}
.tool-container{
  width: 100%;
  margin-top: 15px;
}
.tool-type-ul{
  list-style: none;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 110px;
  border: 1px dashed #F8F8F8;
}
.tool-type-ul img{
  width: 56px;
}
.tool-name{
  line-height: 36px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// Tool.vue?4551a0fc